import React, { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import { getRuntimeEnv } from "../../../providers/getRuntimeEnv";

// Fast spin kicks in once the accelerate keyframe finishes (see logoStyle
// below); particles are timed to start at the same point so they only fly
// once the wheel is at full speed.
const SPIN_UP_DURATION_S = 1.8;
const PARTICLE_COUNT = 100;

export const SyncrosaleLoader = () => {
  const runtimeEnv = useMemo(() => getRuntimeEnv(), []);
  const isDevEnv = runtimeEnv === "dev";
  const theme = useTheme();

  const particles = useMemo(
    () =>
      Array.from({ length: PARTICLE_COUNT }, (_, index) => {
        const angle = (360 / PARTICLE_COUNT) * index;
        const duration = 1.3 + (index % 3) * 0.35;
        const delay = SPIN_UP_DURATION_S + (index % 4) * 0.08;
        return { angle, duration, delay };
      }),
    [],
  );

  return (
    <div style={overlayStyle}>
      <div style={logoWrapperStyle}>
        <img
          src={isDevEnv ? "/icons/logo-dev.svg" : "/icons/logo.svg"}
          alt="Syncrosale loading"
          style={logoStyle}
        />
        {particles.map(({ angle, duration, delay }) => (
          <span
            key={angle}
            style={{
              ...particleWrapperStyle,
              transform: `rotate(${angle}deg)`,
            }}
          >
            <span
              style={{
                ...particleDotStyle,
                backgroundColor: theme.palette.primary.main,
                animationDuration: `${duration}s`,
                animationDelay: `${delay}s`,
              }}
            />
          </span>
        ))}
      </div>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  pointerEvents: "none",
};

const logoWrapperStyle: React.CSSProperties = {
  position: "relative",
  width: 128,
  height: 128,
};

const logoStyle: React.CSSProperties = {
  width: 128,
  height: 128,
  animation:
    "syncrosale-spin-accelerate 1.8s cubic-bezier(0.55, 0.055, 0.675, 0.19) 1, syncrosale-spin-fast 0.12s linear infinite 1.8s",
  pointerEvents: "auto",
};

const particleWrapperStyle: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: 0,
  height: 0,
  pointerEvents: "none",
};

const particleDotStyle: React.CSSProperties = {
  position: "absolute",
  top: -3,
  left: 0,
  width: 8,
  height: 8,
  borderRadius: "50%",
  opacity: 0,
  animationName: "syncrosale-particle",
  animationTimingFunction: "ease-out",
  animationIterationCount: "infinite",
};
